import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { removeTimeSlotByIndex, setMultipleSlotsCount, setRecurringMultipleSlots } from '../../../actions/orders';
import MultipleAppointments from './MultipleAppointments';

const mapStateToProps = ({ order, product, settings }) => ({
  ...settings,
  bodyStyles: settings.style.body,
  buttonStyles: settings.style.button,
  multipleOccurrences: product.data.multiple_occurrences,
  multipleAppointmentsEnabled: settings.multipleAppointmentsEnabled,
  multipleSlotsCount: order.multipleSlotsCount,
  options: product.data.options,
  recurringEnabled: order.recurringMultipleSlots,
  timeSlot: order.timeSlot?.timeSlot,
  timeSlots: order.timeSlots,
  variants: product.data.variants,
  variantSelected: order.variantSelected
});

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({
      removeTimeSlotByIndex,
      setMultipleSlotsCount,
      setRecurringMultipleSlots,
    }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAppointments);
